import { Form, Input, Modal, Button, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import "./PartnerDashboard.css";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import axios from "axios";
import { useEffect, useState } from "react";
import { Upload } from "antd";
import { Tooltip } from "antd";




const AddInvoice = (props) => {
    const [form] = Form.useForm();
    const { Dragger } = Upload;
    const {
        addInvoiceOpen,
        setAddInvoiceOpen,
        dataSource2,
        setDataSource2,
        handleUploadInvoice,
        currentReport,
        getCurrentUserId
    } = props;
    const [invoiceData, setInvoiceData] = useState({
        InvoiceAmount: "",
        InvoiceNumber: "",
        Remark: "",
        InvoicePath: null,
        PayoutPath: null,
        PayoutRemark: ""
    });
    const [submitting, setSubmitting] = useState(false);
    const [invoiceFileList, setInvoiceFileList] = useState([]);
    const [payoutFileList, setPayoutFileList] = useState([]);
    // Handle text input changes
    // const handleChange = (event) => {
    //     setInvoiceData({
    //         ...invoiceData,
    //         [event.target.name]: event.target.value
    //     });
    // };

    useEffect(() => {
       
    }, [invoiceData]);
    

    const handleChange = (event) => {
        // const { name, value } = event.target;
        // const {name,value} = event.target;

    //  const sanitizedValue = value.replace(/[^0-9.+-]/g, '');

    if (event.target.name === "Remark" && event.target.value.length > 250) {
        message.error("Remark cannot exceed 250 characters.");
        return;
    }

        setInvoiceData({
            ...invoiceData,
            [event.target.name]: event.target.value
        });
    }

    const handleAmountChange =(event) =>{
        const { value } = event.target;
        // const finddata = value.match(/[+-]/g);
        // if (finddata){
        //     message.error("number must be posetive");
        //     return 0
        // }
        const filteredValue = value.replace(/[+-]/g, '');
        form.setFieldsValue({
            [event.target.name]: filteredValue
        });
       
         setInvoiceData({
            ...invoiceData,
            [event.target.name]: filteredValue
        });
    }


   

const onReset = () => {
    
    form.resetFields();
     setInvoiceData({
        InvoiceAmount: "",
        InvoiceNumber: "",
        Remark: "",
        InvoicePath: null,
        PayoutPath: null,
        PayoutRemark: ""
    });
    setInvoiceFileList([]);
    setPayoutFileList([]);
    // message.info('Form fields reset!');
  };

    // Handle invoice file upload
    const handleInvoiceFileChange = (info) => {
        if (info.file.status === 'done' || info.file.status === 'uploading' || info.file.status === 'error') {
            setInvoiceData((prev) => ({ ...prev, InvoicePath: info.file.originFileObj }));
        }
    };

    // Handle payout file upload
    const handlePayoutFileChange = (info) => {
        if (info.file.status === 'done' || info.file.status === 'uploading' || info.file.status === 'error') {
            setInvoiceData((prev) => ({ ...prev, PayoutPath: info.file.originFileObj }));
        }
    };

    const handleInvoiceCancel = () => {

        onReset();
        setAddInvoiceOpen(false);
    }

    const handleOk = () => setAddInvoiceOpen(false);


    const handleSubmit = async (event) => {
        // event.preventDefault();
        setSubmitting(true);
        // Validation
        
        if (
            !invoiceData.InvoiceAmount ||
            !invoiceData.InvoiceNumber ||
            !invoiceData.Remark ||
            !invoiceData.InvoicePath 
            // || !invoiceData.PayoutPath
        ) {
            
            message.error('Please fill all fields and attach Invoice PDF.');
            setSubmitting(false);
            if (invoiceData.InvoicePath=== null) {
            setInvoiceFileList([]);
              setInvoiceData({
                 ...invoiceData,
                InvoicePath: null,
            });
            }
            // if (invoiceData.PayoutPath === null) {
            //     setPayoutFileList([]);
            //     setInvoiceData({
            //         ...invoiceData,
            //         PayoutPath: null,
            //     });
            // }
          
            // form.resetFields();
            return;
        }

        const date = new Date();
        const formData = new FormData();
        formData.append('partnerid', currentReport?.partnerId);
        formData.append('invoice_files', invoiceData.InvoicePath);
        formData.append('reportid', currentReport?.reportId);
        formData.append('invoiceNumber', invoiceData.InvoiceNumber);
        formData.append('invoiceDate', date.toISOString().slice(0, 19));
        formData.append('invoiceAmount', invoiceData.InvoiceAmount);
        formData.append('remarks.userId', getCurrentUserId);
        formData.append('remarks.remarksComment', invoiceData.Remark);
        formData.append('remarks.stage', '5');
        formData.append('payout_files', invoiceData.PayoutPath);

        try {
            const res = await handleUploadInvoice(formData);
            message.success(res.message);
            onReset();
            setAddInvoiceOpen(false);
        } catch (error) {
            console.error('Error:', error);
            message.error('Upload failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };



const invoiceUploadProps = {
    name: 'file',
    multiple: false,
    accept: '.pdf',
    showUploadList: {
        showPreviewIcon: false,
        showRemoveIcon: true,
        showDownloadIcon: false,
        removeIcon: <span>✖</span>
    },
    fileList: invoiceFileList,
    customRequest: async ({ file, onSuccess, onError }) => {
        try {
            onSuccess("ok");
        } catch (err) {
            onError("Upload failed. Please try again.");
            message.error('Upload failed. Please try again.');
        }
    },
    beforeUpload: (file) => {
        if (invoiceFileList && invoiceFileList.length > 0) {
        message.error('You can only upload one file.');
        return Upload.LIST_IGNORE;
    }
        const isPDF = file.type === 'application/pdf' && file.name.toLowerCase().endsWith('.pdf');
        if (!isPDF) {
            message.error('Only PDF documents are allowed.');
            return Upload.LIST_IGNORE;
        }
        const isLt250KB =  5 * 1024  * 1024;
        if (file.size >= isLt250KB) {
            message.error('File must be smaller than 5MB.');
            return Upload.LIST_IGNORE;
        }
        message.success('File is attached succesfully.');
        return true;
    },
    onRemove: () => {
        setInvoiceData((prev) => ({ ...prev, InvoicePath: null }));
        setInvoiceFileList([]);
    },
    onChange: (info) => {
        setInvoiceFileList(info.fileList);
        handleInvoiceFileChange(info);
    }
};

const payoutUploadProps = {
    name: 'file',
    multiple: false,
    // accept: '.pdf',
    accept: '.pdf,.csv,.xls,.xlsx',
    showUploadList: {
        showPreviewIcon: false,
        showRemoveIcon: true,
        showDownloadIcon: false,
        removeIcon: <span>✖</span>
    },
    fileList: payoutFileList,
    customRequest: async ({ file, onSuccess, onError }) => {
        try {
            onSuccess("ok");
        } catch (err) {
            onError("Upload failed. Please try again.");
            message.error('Upload failed. Please try again.');
        }
    },
    beforeUpload: (file) => {
    // Check if a file is already present
    if (payoutFileList && payoutFileList.length > 0) {
        message.error('You can only upload one file.');
        return Upload.LIST_IGNORE;
    }

    // const isPDF = file.type === 'application/pdf' && file.name.toLowerCase().endsWith('.pdf');
    // if (!isPDF) {
    //     message.error('Only PDF documents are allowed.');
    //     return Upload.LIST_IGNORE;
    // }

     const allowedTypes = [
            'application/pdf',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ];
        const allowedExtensions = ['.pdf', '.csv', '.xls', '.xlsx'];
        const fileExt = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        const isAllowedType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExt);
        if (!isAllowedType) {
            message.error('Only PDF, Excel, or CSV files are allowed.');
            return Upload.LIST_IGNORE;
        }
    const isLt250KB = 5 * 1024 * 1024;
    if (file.size >= isLt250KB) {
        message.error('File must be smaller than 5MB.');
        return Upload.LIST_IGNORE;
    }
    message.success('File is attached succesfully.');
    return true;
},
    onRemove: () => {
        setInvoiceData((prev) => ({ ...prev, PayoutPath: null }));
        setPayoutFileList([]);
    },
    onChange: (info) => {
         // Only update file list if the file is valid
        const validFiles = info.fileList.filter(f =>
        f.type === 'application/pdf' ||
        f.name.toLowerCase().endsWith('.pdf') ||
        f.type === 'application/vnd.ms-excel' ||
        f.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        f.type === 'text/csv' ||
        f.name.toLowerCase().endsWith('.csv') ||
        f.name.toLowerCase().endsWith('.xls') ||
        f.name.toLowerCase().endsWith('.xlsx') &&
        f.size / 1024 < 250
    );
        setPayoutFileList(validFiles);
        handlePayoutFileChange(info);
    }
};

  
return (
    <Modal
        open={addInvoiceOpen}
        width={500}
        maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
        footer={[]}
        onOk={handleOk}
        onCancel={handleInvoiceCancel}
    >
        <Form
            form={form}
            style={{ margin: "10px" }}
            onFinish={handleSubmit}
            onReset={onReset}
            layout="vertical"
        >
            <div className="container-form" style={{ display: "flex", width: "100%", marginTop: "20px" }}>
                <Form.Item
                    label={<span>Invoice Amount </span>}
                    name="InvoiceAmount"
                    style={{ width: "50%", marginRight: "10px" }}
                    rules={[{ required: true, message: 'Please enter Invoice Amount' },
                        {
            pattern: /^[0-9]*\.?[0-9]*$/,
            message: 'Please enter a valid positive number'
        }
                    ]}
                      getValueFromEvent={(e) => {
                            const value = e.target.value;
                            const hasSignSymbol = value.match(/[+-]/g);
                            if (hasSignSymbol) {
                                message.error("Number must be positive");
                                return value.replace(/[+-]/g, '');
                            }
                            return value;
                        }}
                >
                    <Input
                        style={{ width: "100%", margin: "0px" }}
                        type="text"
                        placeholder="Enter Invoice Amount"
                        min={0}
                        name="InvoiceAmount"
                        value={invoiceData.InvoiceAmount}
                        onChange={handleAmountChange}
                    />
                </Form.Item>
                <Form.Item
                    label={<span>Invoice Number </span>}
                    name="InvoiceNumber"
                    style={{ width: "50%" }}
                    rules={[{ required: true, message: 'Please enter Invoice Number' }]}
                >
                    <Input
                        style={{ width: "100%", margin: "0px" }}
                        placeholder="Enter Invoice Number"
                        name="InvoiceNumber"
                        value={invoiceData.InvoiceNumber}
                        onChange={handleChange}
                    />
                </Form.Item>
            </div>
            <Form.Item
                label={<span>Remark </span>}
                name="Remark"
                style={{ width: "auto", marginTop: "10px" }}
                rules={[{ required: true, message: 'Please enter Remark' }]}
            >
                <TextArea
                    style={{ margin: "0px" }}
                    name="Remark"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    value={invoiceData.Remark}
                    onChange={handleChange}
                    placeholder="Please add comment to submit"
                    maxLength={250}
                    showCount={true}
                />
            </Form.Item>
            <Form.Item label={<span>Invoice Attachment </span>} required>
                <Dragger {...invoiceUploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p>Upload Invoice PDF</p>
                </Dragger>
            </Form.Item>
            <Form.Item label={<span>Payout Attachment </span>} >
                <Dragger {...payoutUploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p>Upload Payout File</p>
                </Dragger>
            </Form.Item>
            <Button disabled={submitting} loading={submitting} className="btn-upload-submit" htmlType="submit" type="primary">SUBMIT</Button>
            {/* <Button
                className="btn-upload-reset"
                htmlType="reset"
                type="default"
                style={{ marginLeft: "10px" }}
            >
                RESET
            </Button> */}
        </Form>
    </Modal>
);

};

export default AddInvoice;